/// <reference path="../../../node_modules/sweetalert2/sweetalert2.d.ts" />
import Swal from "sweetalert2";
import "jquery";

let xhrNumber = 0;

export default function init() {
    window.addEventListener("load", function () {
        search($("#initialPage").val(), true, false);
    });
  
    function search(pageNumber: any, replaceState: boolean, jumpToTop: boolean) {
        let hashtag = $("#hashtag").val();
        if (jumpToTop === true) {
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
            500);
      }
  
        $("#js-blogPostsListingLoader").removeClass("d-none");
  
        $("#js-blogPostsListing").fadeOut();
  
        // Used for just render the last ajax call
        let seqNumber = ++xhrNumber;
  
        $.get("/hashtaglistingpage/blogpostslisting/", {
            page: pageNumber,
            hashtag: hashtag
        })
        .done(function (data) {
          if (xhrNumber === seqNumber) {
            $("#js-blogPostsListing").html(data).hide().fadeIn();
  
            $(".page-link")
              .off("click")
              .click(function () {
                search($(this).data("pagenumber"), false, true);
              });
  
            let currentPage = $("#currentPage").val();
            let title = document.title + " - " + currentPage;
  
            if (!replaceState) {
              history.pushState(
                {
                  content: data,
                  pageTitle: title,
                },
                title,
                "?hashtag=" + 
                hashtag +
                "&page=" + 
                currentPage
              );
            } else {
              history.replaceState(
                {
                  content: data,
                  pageTitle: title,
                },
                title,
                "?hashtag=" + 
                hashtag +
                "&page=" + 
                currentPage
              );
            }
          }
        })
        .fail(function (error) {
          if (xhrNumber === seqNumber) {
            Swal.fire("Oops...", error.statusText, "error");
            $("#js-blogPostsListing").fadeIn();
          }
        })
        .always(function () {
          if (xhrNumber === seqNumber) {
            $("#js-blogPostsListingLoader").addClass("d-none");
          }
        });
    }
  }
  init();